<div
  ktOffcanvas
  [options]="offcanvasOptions"
  id="kt_timeline_offcanvas"
  class="offcanvas offcanvas-right p-5"
>
  <div class="close">
    <a id="kt_timeline_close" class="btn btn-xs btn-icon btn-success">
      <i class="ki ki-close icon-xs"></i>
    </a>
  </div>
  <div class="offcanvas-content h-100">
    <div *ngIf="relatedView$ | async as relatedView" class="row align-items-stretch h-100">
      <div *ngIf="relatedView !== RelatedView.PATIENT" class="col-4 h-100 pr-0">
        <kt-contact-timeline></kt-contact-timeline>
      </div>
      <div [ngClass]="relatedView === RelatedView.PATIENT ? 'col-12' : 'col-8'" class="h-100">
        <kt-activity-record-list></kt-activity-record-list>
      </div>
    </div>
  </div>
</div>
